import { isCutsceneLocked } from "./cutsceneState.js";
import { isEscapeUIOpen } from "../ui/escapeUI.js";
import { isMemoryUIOpen, isMemoryTutorialLocked } from "../ui/memoryUI.js";
import { isTextboxPausing } from "../ui/textboxUI.js";

/**
 * Shared world-pause gate for player, humans, and robots.
 * Boot / onboarding locks stay player-local (see player.js).
 */
export function isGameplayPaused() {
    return isMemoryUIOpen()
        || isTextboxPausing()
        || isMemoryTutorialLocked()
        || isCutsceneLocked()
        || isEscapeUIOpen();
}
